import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { useSchedulingLocationInfo } from '../use-scheduling-location-info';

type Props = {
  providerId: string;
  locationId: string;
};

export const useGetProviderV3 = ({ providerId, locationId }: Props) => {
  const { isMultiLocation } = useSchedulingLocationInfo();
  const { isScheduleV3FlagEnabled } = SchedulerV3.Helpers.useGetSchedulerV3FeatureFlagDetails();

  const { data } = SchedulerV3.Queries.useGetProviderQuery({
    request: {
      id: providerId ?? '',
      childLocationId: isMultiLocation && locationId ? locationId : '',
    },
    options: {
      enabled: !!providerId && isScheduleV3FlagEnabled,
    },
  });

  return data?.provider;
};
